import { Controller } from "@hotwired/stimulus"

// Scales a fixed-width design (the element's first child) to the available
// width, and sizes the frame to the scaled height. Watches both, so a mockup
// that grows (e.g. a panel opening inside it) keeps its frame in sync.
//   <div class="fit" data-controller="fit" data-fit-width-value="1240">
export default class extends Controller {
  static values = { width: Number }

  connect() {
    this.design = this.element.firstElementChild
    this.observer = new ResizeObserver(() => this.fit())
    // Measure with the web font in place: a fallback-font height would shift the page when the font lands
    document.fonts.ready.then(() => {
      if (!this.observer) return
      this.design.style.width = this.widthValue + "px"
      this.observer.observe(this.element)
      this.observer.observe(this.design)
    })
  }

  disconnect() {
    this.observer.disconnect()
    this.observer = null
  }

  fit() {
    const scale = this.element.clientWidth / this.widthValue
    this.design.style.scale = scale
    this.element.style.height = this.design.offsetHeight * scale + "px"
  }
}
